import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';

export const weeklyViewRoutes: Routes = [
  {
    path: 'weekly-view',
    title: 'Wochenansicht',
    loadComponent: () => import('./weekly-view').then(m => m.WeeklyViewComponent),
    canActivate: [authGuard],
  },
];
